const THUMBNAIL_SIZE = 512;

// createImageBitmap с resizeWidth даёт браузеру шанс декодировать сразу в
// уменьшенном виде (не всегда, но почти всегда дешевле, чем decode оригинала
// + downscale вручную). Высоту не задаём — так сохраняется исходный aspect
// ratio, а квадратную обрезку уже делает CSS object-fit на месте показа.
export const createImageThumbnail = async (url: string): Promise<string> => {
  const response = await fetch(url);
  const blob = await response.blob();
  const bitmap = await createImageBitmap(blob, {
    resizeWidth: THUMBNAIL_SIZE,
    resizeQuality: 'medium',
  });

  const canvas = document.createElement('canvas');
  canvas.width = bitmap.width;
  canvas.height = bitmap.height;
  canvas.getContext('2d')?.drawImage(bitmap, 0, 0);
  bitmap.close();

  return new Promise<string>((resolve, reject) => {
    canvas.toBlob(
      (result) =>
        result
          ? resolve(URL.createObjectURL(result))
          : reject(new Error('canvas.toBlob вернул null')),
      'image/webp',
      0.85
    );
  });
};
